module.exports = __webpack_public_path__ + "img/match-4.3f033b75.webp";